import { Check } from "../../../../../SVGS";
import history from "../../../../../history";

// Utils
import { daysLeftTillEndOfSubscription } from "../../../../../utils/timeStampToDate";

// styles
import { PlanStyles } from "./plan.styles";

// Translucent "glass" plan card that sits inside the dark-blue dashboard header.
// Opens the billing hub (subscription panel + payment methods) — the only
// discoverable path to plan management once onboarding is done.
const Plan = ({ subscriptionPlanName, subscriptionPlanEndPeriod }) => {
  return (
    <PlanStyles onClick={() => history.push("/business-profile")}>
      <span className="check">
        <Check stroke="#ffffff" width="12" height="12" />
      </span>
      <div className="body">
        <p className="label">Current plan</p>
        <h2 className="title">{subscriptionPlanName}</h2>
        <p className="meta">
          Renews in{" "}
          {daysLeftTillEndOfSubscription(
            new Date(subscriptionPlanEndPeriod).getTime() / 1000 // fn works in seconds
          )}{" "}
          days
        </p>
      </div>
      <p className="manageHint">Manage</p>
    </PlanStyles>
  );
};

export default Plan;
